import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Input,
  Button,
  Spin,
  Tabs,
  Radio,
  Divider,
  message,
  Space,
  List,
  Avatar,
  Alert,
  Pagination,
  Tag,
  Modal,
} from "antd";
import Post from "../services/Post";
import io from "socket.io-client";
import { useNavigate, useParams } from "react-router-dom";
import Get from "../services/Get";
import Search from "antd/lib/input/Search";

const JoinMLMScheme = () => {
  const [activeTab, setActiveTab] = useState("free");
  const [referCode, setReferCode] = useState("COMPANY");
  const [paymentMethod, setPaymentMethod] = useState("online");
  const [processing, setProcessing] = useState(false);
  const [processingId, setProcessingId] = useState(null);
  const [showJoin, setShowJoin] = useState(false);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [mainUser, setMainUser] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [unpaidCount, setUnpaidCount] = useState("..");
  const [paidCount, setPaidCount] = useState("..");
  const [starCount, setStarCount] = useState("..");
  const [silverCount, setSilverCount] = useState("..");
  const [goldCount, setGoldCount] = useState("..");
  const [platinumCount, setPlatinumCount] = useState("..");
  const [diamondCount, setDiamondCount] = useState("..");
  const [userDetails, setUserDetails] = useState({});
  const [selectedFilter, setSelectedFilter] = useState('');
  const [totalAmount, setTotalAmount] = useState();

  let { user } = useParams();
  if (user) {
    user = atob(user);
  }
  const navigate = useNavigate();
  const joiningUser = JSON.parse(localStorage.getItem("user"));

  const joiningFee = 600;
  const gst = joiningFee * 0.18;
  // const totalAmount = joiningFee + gst;

  const getData = async (page = 1, reg_no, filter) => {
    setLoading(true);
    try {
      const res = await Get.MLMNetwork(
        user || "",
        page,
        reg_no || "",
        filter || ""
      );
      if (res.error && res.error === "Not registered") {
        setTotalAmount(res.joiningFees);
        setShowJoin(true);
        return;
      }
      if (res.error) {
        message.error(res.error);
      } else {
        setShowJoin(false);
        setMembers(res.data.data); // paginated data
        setMainUser(res.user);
        setTotal(res.data.total); // total count
        setUnpaidCount(res.unpaidCount);
        setPaidCount(res.paidCount);
        setStarCount(res.starCount);
        setSilverCount(res.silverCount);
        setGoldCount(res.goldCount);
        setPlatinumCount(res.platinumCount);
        setDiamondCount(res.diamondCount);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (filter) => {
    setSelectedFilter(filter);
    getData(1, "", filter);
  };

  const getSingleUserData = async (id) => {
    setProcessingId(id); // Track which button is loading
    try {
      const res = await Get.MLMUserDetails(id);
      if (res.error) {
        message.error(res.error);
      } else {
        console.log(res.data);
        setUserDetails(res.data);
        setShowUserDetails(true);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setProcessingId(null); // Reset after completion
    }
  };

  const pay_now = async () => {
    try {
      let amount = totalAmount;

      if (!amount) {
        message.error("Amount not found!");
        return null;
      }

      setProcessing(true);

      const res = await Post.PaymentLink(amount);
      console.log(res);

      const { paymentLink, order_id } = res.data;

      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setProcessing(false);
        return null;
      }

      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );

      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setProcessing(false);
        return null;
      }

      let popupClosed = false;

      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setProcessing(false);
            reject(null);
          }
        }, 1000);

        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        console.log(order_id);
        socket.emit("join-room", order_id);
        console.log("room joined");

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;

          if (popupClosed) return;

          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setProcessing(false);
      return null;
    }
  };

  const handleSubmit = async () => {
    setProcessing(true);
    console.log("joiningUser", joiningUser);

    if (!joiningUser.parent_code && referCode == "") {
      message.warn("Refer Code is required");
      setProcessing(false);
      return;
    }

    try {
      const data = {
        plan: activeTab,
        refer_code: joiningUser.parent_code
          ? joiningUser.parent_code
          : referCode,
      };

      if (activeTab == "paid") {
        data.amount = totalAmount;
        data.method = paymentMethod;
        data.description = "Successfully Joined MLM Scheme";
        if (paymentMethod == "online") {
          const payId = await pay_now();
          data.pay_id = payId;
        }
      }

      console.log(data);

      const res = await Post.JoinMlm(data);
      console.log("Response == ", res);

      if (res) {
        if (res.error) {
          console.log(res.error);
          message.error(res.error);
        } else {
          console.log("Success!");
          message.success("Successfully joined MLM!");
        }
      }
    } catch (error) {
      message.error(error);
    } finally {
      getData();
      setProcessing(false);
    }
  };

  const handleSearch = async () => {
    getData(1, searchQuery);
  };

  useEffect(() => {
    getData(currentPage, searchQuery, selectedFilter);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getRankTag = (rank) => {
    if (rank === "star") return <Tag color="blue">Star</Tag>;
    if (rank === "silver") return <Tag color="green">Silver</Tag>;
    if (rank === "gold") return <Tag color="gold">Gold</Tag>;
    if (rank === "platinum") return <Tag color="grey">Platinum</Tag>;
    if (rank === "diamond") return <Tag color="red">Diamond</Tag>;
  };

  const getLevelTag = (level) => {
    if (level === 1) return <Tag color="green">Direct</Tag>;
    return <Tag color="purple">Level {level}</Tag>;
  };

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} md={22}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh", // Makes it full-screen height
              }}
            >
              <Spin size="large" />
            </div>
          ) : showJoin ? (
            <Card bordered={true}>
              <Alert
                message="If you wanna join directly from company submit 'COMPANY' as refer code!"
                type="info"
                showIcon
              />
              <Tabs defaultActiveKey="free" onChange={setActiveTab}>
                {/* Free Plan */}
                <Tabs.TabPane tab="Free Plan" key="free">
                  <Row style={{ marginBottom: 16 }}>
                    <Col span={24}>
                      <Typography.Text strong>
                        Enter Refer Code:
                      </Typography.Text>
                      <Input
                        type="text"
                        placeholder="Enter refer code"
                        value={
                          joiningUser.parent_code
                            ? joiningUser.parent_code
                            : referCode
                        }
                        onChange={(e) => setReferCode(e.target.value)}
                        style={{ marginTop: 8 }}
                        disabled={
                          processing || joiningUser.parent_code !== null
                        }
                      />
                    </Col>
                  </Row>

                  <Typography.Paragraph>
                    ✅ Join for <strong>Free</strong> <br />✅ Earn{" "}
                    <strong>8% commission</strong> on direct referral <br />✅
                    You can upgrade later your current plan with paid plan
                  </Typography.Paragraph>

                  <Button
                    type="primary"
                    block
                    className="form-btn"
                    onClick={handleSubmit}
                    loading={processing}
                  >
                    Join Free Plan
                  </Button>
                </Tabs.TabPane>

                {/* Paid Plan */}
                <Tabs.TabPane tab="Paid Plan" key="paid">
                  <Row style={{ marginBottom: 16 }}>
                    <Col span={24}>
                      <Typography.Text strong>
                        Enter Refer Code:
                      </Typography.Text>
                      <Input
                        type="text"
                        placeholder="Enter refer code"
                        value={
                          joiningUser.parent_code
                            ? joiningUser.parent_code
                            : referCode
                        }
                        onChange={(e) => setReferCode(e.target.value)}
                        style={{ marginTop: 8 }}
                        disabled={
                          processing || joiningUser.parent_code !== null
                        }
                      />
                    </Col>
                  </Row>
                  <Typography.Paragraph>
                    ✅ Joining amount <strong>₹600 + GST</strong> <br />✅ Earn{" "}
                    <strong>15% commission</strong> on direct referral
                  </Typography.Paragraph>
                  <Divider />
                  <Typography.Title level={5}>Payment Summary</Typography.Title>
                  <Typography.Text>
                    Joining Fees: ₹{joiningFee}
                  </Typography.Text>{" "}
                  <br />
                  <Typography.Text>
                    GST (18%): ₹{gst.toFixed(2)}
                  </Typography.Text>{" "}
                  <br />
                  <Typography.Text strong>
                    Total Amount: ₹{totalAmount.toFixed(2)}
                  </Typography.Text>
                  <Divider />
                  <Radio.Group
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    value={paymentMethod}
                    style={{ display: "block", margin: "20px 0" }}
                  >
                    <Radio value="online">Online Payment</Radio>
                    <Radio value="wallet">Wallet</Radio>
                  </Radio.Group>
                  <Button
                    type="primary"
                    block
                    className="form-btn"
                    onClick={handleSubmit}
                    disabled={processing}
                  >
                    {processing ? (
                      <Spin size="small" />
                    ) : (
                      `Pay ₹${totalAmount.toFixed(2)}`
                    )}
                  </Button>
                </Tabs.TabPane>
              </Tabs>
            </Card>
          ) : (
            <Space
              direction="vertical"
              size="middle"
              style={{
                display: "flex",
                marginBottom: 20,
              }}
            >
              {/* {uplineUser && (
                <Row justify={"center"} className="mb-4">
                  <Col span={12}>
                    <Card title="Your Upline" variant="borderless">
                      Name: {uplineUser.name}
                      <br />
                      Mobile: {uplineUser.mobile}
                    </Card>
                  </Col>
                </Row>
              )} */}
              <Row justify={"space-between"} style={{marginLeft: '0px'}}>
                <Typography.Title level={3}>
                  {mainUser.user.name}{" "}
                  {mainUser.rank && getRankTag(mainUser.rank.user_rank)}
                </Typography.Title>
                <div>
                  {user && mainUser.upline_id && (
                    <Button
                      type="primary"
                      className="form-btn"
                      onClick={() =>
                        navigate(
                          `/user/affiliate-program/${
                            mainUser.upline_id == joiningUser.id
                              ? ""
                              : btoa(mainUser.upline_id)
                          }`
                        )
                      }
                    >
                      View Upline
                    </Button>
                  )}
                  {/* <Button
                    type="primary"
                    style={{ marginLeft: 10 }}
                    className="form-btn"
                    onClick={() =>
                      navigate(`/user/affiliate-tree/${btoa(mainUser.user.id)}`)
                    }
                  >
                    View Tree
                  </Button> */}
                </div>
              </Row>
              <Row gutter={[10, 10]} className="mb-4">
                <Col span={24}>
                  <Search
                    placeholder={`Enter Registration Number`}
                    enterButton={
                      <button className="search-button">Search</button>
                    }
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onSearch={handleSearch}
                    allowClear
                  />
                </Col>
              </Row>
              <Row gutter={[10, 10]} className="sapn_3">
                  <Button
                    onClick={() => handleFilter("unpaid")}
                    className={`form-btn unpaid ${selectedFilter == 'unpaid' && 'selected-filter'}`}
                  >
                    Unpaid {unpaidCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("paid")}
                    className={`form-btn paid ${selectedFilter == 'paid' && 'selected-filter'}`}
                  >
                    Paid {paidCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("star")}
                    className={`form-btn star ${selectedFilter == 'star' && 'selected-filter'}`}
                  >
                    Star {starCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("silver")}
                    className={`form-btn silver ${selectedFilter == 'silver' && 'selected-filter'}`}
                  >
                    Silver {silverCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("gold")}
                    className={`form-btn gold ${selectedFilter == 'gold' && 'selected-filter'}`}
                  >
                    Gold {goldCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("platinum")}
                    className={`form-btn platinum ${selectedFilter == 'platinum' && 'selected-filter'}`}
                  >
                    Platinum {platinumCount}
                  </Button>
                
                
                  <Button
                    onClick={() => handleFilter("diamond")}
                    className={`form-btn diamond ${selectedFilter == 'diamond' && 'selected-filter'}`}
                  >
                    Diamond {diamondCount}
                  </Button>
                
              </Row>
              <Card>
                <List
                  header={
                    <Typography.Title level={4}>Members</Typography.Title>
                  }
                  bordered
                  loading={loading}
                  dataSource={members}
                  renderItem={(item) => (
                    <List.Item className="list_bttuns"
                      actions={[
                        <Button
                          type="primary"
                          className="form-btn"
                          onClick={() =>
                            navigate(
                              `/user/affiliate-program/${btoa(item.user_id)}`
                            )
                          }
                        >
                          View Members
                        </Button>,
                        <Button
                          type="primary"
                          className="form-btn"
                          loading={processingId === item.user_id}
                          onClick={() => getSingleUserData(item.user_id)}
                        >
                          View Details
                        </Button>,
                      ]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            src={`https://manage.rebatedekho.com/uploads/avatar/${item.user.avatar}`}
                            alt="Avatar"
                          />
                        }
                        title={
                          <>
                            {item.user.name}{" "}
                            {item.rank?.user_rank &&
                              getRankTag(item.rank?.user_rank)}
                            {item?.associatedLevel && getLevelTag(item.associatedLevel)}
                          </>
                        }
                        description={
                          <>
                            Registration No.:{" "}
                            <Typography.Text>{item.reg_no}</Typography.Text>
                            <br />
                            Plan:{" "}
                            <Typography.Text>{item.plan_type}</Typography.Text>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
                <Row justify={"end"}>
                  <Pagination
                    current={currentPage}
                    total={total}
                    pageSize={10}
                    style={{ marginTop: 20 }}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </Row>
              </Card>
            </Space>
          )}
        </Col>
        <Modal
          title="User Details"
          open={showUserDetails}
          onCancel={() => setShowUserDetails(false)}
          footer={null}
        >
          {userDetails && (
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex" }}
            >
              <Typography.Text>
                <strong>Registration Number:</strong> {userDetails.reg_no}
              </Typography.Text>
              <Typography.Text>
                <strong>Name:</strong> {userDetails.user?.name}
              </Typography.Text>
              {userDetails.showMobile && (
                <Typography.Text>
                  <strong>Mobile:</strong> {userDetails.user?.mobile}
                </Typography.Text>
              )}
              <Typography.Text>
                <strong>Plan Type:</strong> {userDetails.plan_type}
              </Typography.Text>
              <Typography.Text>
                <strong>Rank:</strong>{" "}
                {getRankTag(userDetails.rank?.user_rank) || "User"}
              </Typography.Text>
              <Typography.Text>
                <strong>Team Count:</strong> {userDetails.team_count}
              </Typography.Text>
            </Space>
          )}
        </Modal>
      </Row>
    </div>
  );
};

export default JoinMLMScheme;
